import queries from '@apis/queries';
import AuthGuard from '@components/AuthGuard';
import Image from '@components/Image';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useAppCustom from '@hooks/useAppCustom';
import { Link } from '@router/Link';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import BellIcon from './BellIcon';
import MenuIcon from './MenuIcon';
import styles from './styles.module.scss';

function Header() {
  const setSidebar = useSetAtom(isSidebarOpenAtom);
  const openSidebar = () => setSidebar(true);
  const { logo } = useAppCustom().main;
  const { user } = useUser();
  const { data } = useQuery({
    ...queries.notifications.unread(),
    enabled: !!user,
  });
  return (
        <header className={styles.container} >
            <button className={styles.button}
                    onClick={openSidebar}>
                <MenuIcon/>
            </button>
            {logo && (
                <LogoImage src={logo}
                       alt='브랜드 로고' />
            )}
            <AuthGuard className={styles.icon}>
                <Link activityName='NotificationActivity'
                      activityParams={{}} >
                    <button className={styles.button}>
                        <BellIcon/>
                        {data?.hasUnread && (
                            <Dot/>
                        )}
                    </button>
                </Link>
            </AuthGuard>
        </header>
  );
}

const LogoImage = styled(Image)`
    height: 30px;
    //aspect-ratio: 2.3;
    object-fit: contain;
    width: 100%;
`;

const Dot = styled.div`
    width: 8px;
    height: 8px;
    position: absolute;
    background-color: ${colors.red};
    right: 0;
    top: 0;
    border-radius: 4px;
`;

export default Header;
